
import Vue from "vue";
import store from '../store';
import ConditionColor from "./ConditionColor.vue";
import { ICondition } from "@/shared/models/condition.model";

export default Vue.extend({
    name: "ConditionItem",

    components: {
        ConditionColor
    },

    props: {
        item: Object as () => ICondition,
        color: String,
        sameCondition: Boolean,
        twoConditions: Boolean,
        tdUrl: String,
    },
    data() {
        return {
        };
    },
    watch: {
    },
    methods: {
        isAdmin(): boolean {
            return store.state.isTdAdmin;
        },
        openTd() {
            window.open(this.tdUrl, '_blank');
        },
        getConditionClass(): string {
            let className = "normal-text";
            if (this.twoConditions) {
                if (this.item.Condition.length > 70) {
                    className = "small-text";
                }
            }
            return className;
        }
    },
});
